import { render, staticRenderFns } from "./SeletorPeriodo.vue?vue&type=template&id=157124ae&scoped=true"
import script from "./SeletorPeriodo.vue?vue&type=script&lang=js"
export * from "./SeletorPeriodo.vue?vue&type=script&lang=js"
import style0 from "./SeletorPeriodo.vue?vue&type=style&index=0&id=157124ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157124ae",
  null
  
)

export default component.exports